import type { FloorplanDocumentV2 } from "./floorplan-document.ts";

/** Private images never enter a shared payload. Only reattach images from the
 * same project/source; texture crops must also match the accepted geometry. */
export function preserveLocalAttachments(incoming: FloorplanDocumentV2, local: FloorplanDocumentV2 | null): FloorplanDocumentV2 {
  if (!local || incoming.id !== local.id) return incoming;
  const sourceKey = (d: FloorplanDocumentV2) => JSON.stringify([d.source.name, d.source.mimeType, d.source.width, d.source.height]);
  if (sourceKey(incoming) !== sourceKey(local)) return incoming;
  const cropKey = (l: FloorplanDocumentV2["levels"][number]) => JSON.stringify([l.sourceRegion, l.structure.footprint, l.structure.sourceRotationDegrees, l.structure.rotationCenter]);
  return { ...incoming, source: { ...incoming.source, ...(local.source.previewDataUrl ? { previewDataUrl: local.source.previewDataUrl } : {}) },
    levels: incoming.levels.map(level => {
      const previous = local.levels.find(l => l.id === level.id && cropKey(l) === cropKey(level));
      return previous?.structure.floorTextureUrl ? { ...level, structure: { ...level.structure, floorTextureUrl: previous.structure.floorTextureUrl } } : level;
    }) };
}
